export const OAUTH_ACCOUNT_SHOW_TABS = ['general'] as const;
export type OAuthAccountShowTab = (typeof OAUTH_ACCOUNT_SHOW_TABS)[number];
export const OAUTH_ACCOUNT_DEFAULT_TAB: OAuthAccountShowTab = 'general';
